/**
 * The project's tabs (decision 0056): five, one question each. Overview (where do we stand?, the default) · Chat · Plan
 * · Team · Needs you. Plan has four layouts in the URL (List · Board · Canvas · Outputs); Needs you groups by verb.
 */
export const projectTabs = ["overview", "chat", "plan", "team", "needs"] as const
export type ProjectTab = (typeof projectTabs)[number]

export const planLayouts = ["list", "board", "canvas", "outputs"] as const
export type PlanLayout = (typeof planLayouts)[number]

export const needsVerbs = ["decide", "answer", "review", "allow", "do", "sort"] as const
export type NeedsVerb = (typeof needsVerbs)[number]

export const tabLabels: Record<ProjectTab, string> = {
  overview: "Overview",
  chat: "Chat",
  plan: "Plan",
  team: "Team",
  needs: "Needs you",
}
